import immerHandleActions from 'redux/utils/immerHandleActions';

import { updateHeaders, updateHeadersAction } from './actions';

const init = () => ({
	WCTrustedToken: '',
	WCToken: '',
	WCPersonalization: '',
});

const reducer = {
	[updateHeaders](state: any, action: updateHeadersAction) {
		return { ...state, ...action.payload };
	},
};

export default immerHandleActions(reducer, init());
